<template>
    <auth-layout :minHeight="formMinHeight">
        <div slot="content" v-loading="isLoginProgressing" class="login-wrap" element-loading-text="登录中...">
            <el-tabs v-model="activeTabName" :stretch="true" @tab-click="onTabClick">
                <div :class="customActiveBarClass"/>
                <el-tab-pane :name="TAB_NAME_LOGIN" label="密码登录">
                    <el-form ref="loginForm" :model="loginForm" :rules="loginFormRules" class="login-form"
                             @keypress.native="onKeypress">
                        <el-form-item prop="username">
                            <el-input v-model="loginForm.username" placeholder="请输入用户名" size="medium"/>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input v-model="loginForm.password" placeholder="请输入密码" show-password
                                      size="medium"
                                      type="password"/>
                        </el-form-item>
                        <div class="forgot-password-row">
                            <span class="forgot-password-text" @click="onClickForgotPasswordBtn">忘记密码?</span>
                        </div>
                        <el-button class="submit-btn username-login-submit-btn" type="primary" @click="loginByUsername">
                            登录
                        </el-button>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane :name="TAB_NAME_LOGIN_WITH_SMS" label="短信登录">
                    <el-form ref="loginBySmsForm" :model="loginBySmsForm" :rules="loginBySmsFormRules"
                             class="login-by-sms-form">
                        <el-form-item prop="phone">
                            <el-input v-model="loginBySmsForm.phone" placeholder="请输入手机号" size="medium"/>
                        </el-form-item>

                        <el-form-item prop="code">
                            <el-input v-model="loginBySmsForm.code" placeholder="请输入手机验证码" size="medium">
                                <div slot="append" class="input-append">
                                    <send-msg-with-captcha :phone="loginBySmsForm.phone" :typ="SMS_CODE_TYPE_LOGIN"/>
                                </div>
                            </el-input>
                        </el-form-item>

                        <el-button v-loading="isLoginProgressing" class="submit-btn" type="primary" @click="loginBySms">
                            登录
                        </el-button>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane :name="TAB_WX_QR_LOGIN" label="企业微信">
                    <div id="wx-qrcode"/>
                </el-tab-pane>
            </el-tabs>
        </div>
    </auth-layout>
</template>

<script>
import { mapState } from 'vuex';
import queryString from 'query-string';

import { helper } from '@x-tech/fe-puma-lib';
import { getAESInfo, encrypt } from '@/helper/crypto/encryption';
import AuthLayout from '../Layout/AuthLayout';

import { IS_LOCAL } from '@/config';
import * as authHelper from '@/helper/auth';
import * as utilsHelper from '@/helper/utils';
import * as wxHelper from '@/helper/wx';
import * as authApi from '@/api/auth';

import { SMS_CODE_TYPE_LOGIN } from './SendSmsCodeBtn';
import SendMsgWithCaptcha from './SendSmsCodeWithCaptcha';

import loginSuccessMixin from '@/components/Login/mixin/loginSuccess';
import handleWXCallbackMixin from '@/components/Login/mixin/handleWXCallback';
import { isLoggedInAsync } from '@/helper/auth';

const formHelper = helper.form;

const TAB_NAME_LOGIN = 'TAB_NAME_LOGIN';
const TAB_NAME_LOGIN_WITH_SMS = 'TAB_NAME_LOGIN_WITH_SMS';
const TAB_WX_QR_LOGIN = 'TAB_WX_QR_LOGIN';

const REDIRECT_FROM_OA = 'oa';
const REDIRECT_FROM_WX = 'wx';
const REDIRECT_FROM_TOKEN = 'token';

const formMinHeight = '456px';

export function canThreePartyLogin(params) {
    let { from } = params;
    return [REDIRECT_FROM_OA, REDIRECT_FROM_WX, REDIRECT_FROM_TOKEN].includes(from);
}

export default {
    name: 'Login',
    components: {
        AuthLayout,
        SendMsgWithCaptcha
    },
    mixins: [loginSuccessMixin, handleWXCallbackMixin],
    data() {
        return {
            formMinHeight,
            isSsoLoginProgressing: false,
            isLoginProgressing: false,

            loginForm: {
                username: IS_LOCAL ? 'XC12950' : '',
                password: ''
            },
            loginFormRules: {
                username: [{ required: true, message: '请输入账号', trigger: 'blur' }, formHelper.rules.username],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
            },

            isSendSmsInCoolDown: false,
            sendSmsCoolDownTimer: 0,
            sendSmsBtnText: '发送验证码',
            loginBySmsForm: {
                username: '',
                phone: '',
                captcha: '',
                code: ''
            },
            loginBySmsFormRules: {
                phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }, formHelper.rules.mobile],
                code: [{ required: true, message: '请输入收到的手机验证码', trigger: 'blur' }],
                captcha: []
            },

            activeTabIndex: 0,
            activeTabName: TAB_NAME_LOGIN,
            TAB_NAME_LOGIN,
            TAB_NAME_LOGIN_WITH_SMS,
            TAB_WX_QR_LOGIN,
            SMS_CODE_TYPE_LOGIN
        };
    },
    computed: {
        customActiveBarClass() {
            return {
                'custom-active-bar': true,
                [`custom-active-bar-active${this.activeTabIndex}`]: true
            };
        },
        ...mapState(['sessionId'])
    },
    async created() {
        await this.handleSilentLogin();

        if (await authHelper.isLoggedInAsync()) {
            let accessToken;
            try {
                const cookie = JSON.parse(authHelper.getCookie());
                accessToken = cookie.accessToken;
            } catch (e) {
                console.error(e);
                await authHelper.logout();
                return;
            }

            let redirect = this.$route.query.redirect;
            if (!redirect) {
                redirect = '/welcome';
            }
            if (await this.$_handleRedirect(redirect, accessToken)) {
                return;
            }
        }

        let username = this.$route.params.username;
        if (typeof username !== 'undefined') {
            this.loginForm.username = username;
        }
        await authHelper.logout();
    },
    methods: {
        onTabClick(tab) {
            const { index, name } = tab;
            this.activeTabIndex = index;

            if (name === TAB_WX_QR_LOGIN) {
                this.wxQRCodeLoginInit();
            }
        },
        onKeypress(e) {
            if (e.keyCode === 13) {
                if (this.activeTabName === 'TAB_NAME_LOGIN') {
                    this.loginByUsername();
                } else if (this.activeTabName === 'TAB_NAME_LOGIN_WITH_SMS') {
                    this.loginBySms();
                }
            }
        },
        onClickForgotPasswordBtn() {
            this.$router.push('/forgotPassword');
        },
        loginByUsername() {
            this.$log('loginByUsername');
            this.login('loginForm', this.loginForm, authApi.login);
        },
        loginBySms() {
            this.$log('loginBySms');
            let params = {
                ...this.loginBySmsForm,
                clientId: this.sessionId
            };
            this.login('loginBySmsForm', params, authApi.loginBySms);
        },
        async loginByUsernameWithEncrypt(form = {}, productCode = '') {
            const key = await getAESInfo();
            const paramsRaw = {
                ...form,
                clientId: key.clientId,
                productCode: productCode
            };
            const encryptedParams = encrypt(JSON.stringify(paramsRaw), key.AESKey);
            return await authApi.loginWithEncrypt({
                encryptInfo: {
                    clientId: key.clientId,
                    encryptInfo: encryptedParams
                }
            });
        },
        login(formRefName = '', form = {}, api = {}) {
            this.$refs[formRefName].validate(async valid => {
                if (!valid) {
                    return false;
                }
                const productCode = this.$route.query['productCode'];
                this.isLoginProgressing = true;

                let res;

                if (formRefName === 'loginForm') {
                    // 用户名密码登录 参数加密
                    try {
                        res = await this.loginByUsernameWithEncrypt(form, productCode);
                    } catch (e) {
                        // 加密登录失败，自动尝试非加密方式
                        // 用户名密码错误，不重试
                        if (e.code === '081') {
                            this.isLoginProgressing = false;
                            return;
                        }
                        // 帐号被锁定 不重试
                        if (e.code === '001') {
                            this.isLoginProgressing = false;
                            return;
                        }

                        try {
                            res = await api({ ...form, productCode });
                        } catch (e) {
                            console.error(e);
                            this.isLoginProgressing = false;
                            return;
                        }
                    }
                } else {
                    try {
                        res = await api({ ...form, productCode });
                    } catch (e) {
                        // 这里 http 帮助方法会显示错误信息，不需要再调用一次 message.error
                        console.error(e);
                        this.isLoginProgressing = false;
                        return;
                    }
                }

                try {
                    await this.$_loginSuccess(res);
                } catch (e) {
                    console.error(e);
                    this.$message.error('登录失败，请稍后重试');
                } finally {
                    this.isLoginProgressing = false;
                }
            });
        },
        async wxQRCodeLoginInit() {
            await utilsHelper.loadScript('https://rescdn.qqmail.com/node/ww/wwopenmng/js/sso/wwLogin-1.0.0.js');

            const { agentId, portalUrl } = wxHelper.getWXConfigByDomain();

            let redirectURL = `${portalUrl}/#/third/wxlogin`;
            const redirect = this.$route.query.redirect;
            const productCode = this.$route.query.productCode;
            if (typeof redirect !== 'undefined') {
                redirectURL += `?redirect=${encodeURIComponent(redirect)}&productCode=${productCode}`;
            }

            // 微信的 sdk 决定的名字
            // eslint-disable-next-line new-cap
            window.WwLogin({
                id: 'wx-qrcode',
                appid: window.XCConfig.VUE_APP_WX_APPID,
                agentid: agentId,
                // eslint-disable-next-line camelcase
                redirect_uri: encodeURIComponent(redirectURL),
                state: 'state',
                href: ''
            });
        },
        async oaSilenceLogin() {
            const appId = window.XCConfig.VUE_APP_OA_APPID;
            const redirect = this.$route.query.redirect;
            const baseURL = `${window.location.protocol}//${window.location.host}${window.location.pathname}/#/third/oalogin`;
            const query = queryString.stringify({ redirect });
            const serviceURL = encodeURIComponent(`${baseURL}?${query}`);
            window.location.href = `${window.XCConfig.VUE_APP_IMS_URL}/sso/web/index.html?service=${serviceURL}&appId=${appId}`;
        },
        async wxSilenceLogin() {
            await this.$_handleWXCallback();
        },
        async tokenSilenceLogin(token = '') {
            const redirect = this.$route.query['redirect'];
            if (authHelper.isValidAccessToken(token)) {
                let res;
                try {
                    res = await authApi.getUserSecureByToken({ token });
                } catch (e) {
                    await this.$router.push({ path: '/login', query: { redirect } });
                    return;
                }
                await this.$_loginSuccess(res);
                return;
            } else {
                await this.$router.push({ path: '/login', query: { redirect } });
                return;
            }
        },
        async handleSilentLogin() {
            let { from, token } = this.$route.query;
            if (!token) {
                // TODO token 可能会带末尾的 '/'
                let search = queryString.parse(window.location.search);
                token = search.token;
            }

            if (from === REDIRECT_FROM_OA) {
                await this.oaSilenceLogin();
            } else if (from === REDIRECT_FROM_WX) {
                await this.wxSilenceLogin();
                // 为了兼容之前的版本，需要在存在 token 参数的时候，直接尝试
            } else if (from === REDIRECT_FROM_TOKEN || authHelper.isValidAccessToken(token)) {
                await this.tokenSilenceLogin(token);
            } else {
                // TODO 删除 from 参数
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../Layout/authLayout.scss';

.custom-active-bar {
    height: 3px;
    border-radius: 3px;
    background: #b81b22;
    width: 30px;
    position: absolute;
    // el-tabs__header 的下外边距
    top: -(15px - 3px);
    transform: translateX(0px);
    transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

// left 增加 104px + 10px
.custom-active-bar-active0 {
    transform: translateX(40px);
}

.custom-active-bar-active1 {
    transform: translateX(21px + 171px);
}

.custom-active-bar-active2 {
    transform: translateX(2px + 171px * 2);
}

.login-form {
    padding-top: 40px;
}

.login-by-sms-form {
    padding-top: 40px;
}

.forgot-password-row {
    margin-bottom: 30px;
    text-align: right;
}

.forgot-password-text {
    cursor: pointer;
    color: #999;
    font-size: 14px;
}

.submit-btn {
    width: 100%;
    height: 40px;
    font-size: 14px;
    margin-top: 20px;
}

.version-wrap {
    position: absolute;
    left: 0;
    bottom: -64px;
    font-size: 12px;
    color: rgb(139, 154, 175);
    text-align: center;
    width: 100%;
}

#wx-qrcode {
    padding: 10px 0;
    text-align: center;
}

// 临时提醒用户，切换域名
.notice {
    font-size: 13px;
    color: #f56c6c;
    margin-top: 20px;
    line-height: 1.6;
    background: #fef0f0;
    padding: 8px;
    box-sizing: border-box;
    border-radius: 6px;

    .link {
        color: #F00;
        text-decoration: underline;
        font-weight: bold;
    }
}
</style>
